import React from 'react'

export type Ingredients = {
  amount: string
  prepreparations: string[]
  ingredient: string
  unitOfMeasurement: string
  id: number
}[]

export const IngredientsList = (props: { ingredients: Ingredients }) => (
  <ul className="list--table">
    {props.ingredients.map((ingr) => {
      const { amount, id, ingredient, prepreparations, unitOfMeasurement } =
        ingr
      return (
        ingr.ingredient && (
          <li key={id} className="list__item">
            <span className="list__col">{amount || ''}&nbsp;</span>
            <span className="list__col" aria-hidden={!unitOfMeasurement}>
              {unitOfMeasurement.toLocaleLowerCase()}
              {unitOfMeasurement && <>&nbsp;</>}
            </span>
            <span className="list__col">
              {ingredient}
              {prepreparations.filter((p) => p !== '').length > 0 &&
                prepreparations.map(
                  (prePreparation) =>
                    prePreparation != '' &&
                    `, ${prePreparation.toLocaleLowerCase()}`
                )}
            </span>
          </li>
        )
      )
    })}
  </ul>
)
